import script from "./SelectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectInput.vue?vue&type=script&lang=ts&setup=true"

import "./SelectInput.vue?vue&type=style&index=0&id=64009d47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64009d47"]])

export default __exports__